import React, { FC } from 'react';

import { LabelsChips } from 'src/common/components/labels-chips';
import { LABELS_CHIPS_DAID } from 'src/common/components/labels-chips/LabelsChips.constants';

import { MFA_SESSION_LABELS_LABELS } from './MfaSessionLabels.labels';

type MfaSessionLabelsProps = {
	labels: string[];
};

export const MfaSessionLabels: FC<MfaSessionLabelsProps> = ({ labels }) => (
	<LabelsChips
		labels={labels}
		popupTitle={MFA_SESSION_LABELS_LABELS.POPUP_TITLE}
		dataAutomationId={LABELS_CHIPS_DAID}
	/>
);
